import type { ProjectType } from "../../types/index.js";
import { calculateKitchen } from "./kitchen.js";
import { calculateBathroom } from "./bathroom.js";
import { calculateEnsuite } from "./ensuite.js";
import { calculateBasement } from "./basement.js";
import { calculateBasementSuite } from "./basement-suite.js";
import { calculateAddition } from "./addition.js";
import { calculateDeckPatio } from "./deck-patio.js";
import { calculateLivingRoom } from "./living-room.js";
import { calculateFamilyRoom } from "./family-room.js";
import { calculateDiningRoom } from "./dining-room.js";
import { calculateBedroom } from "./bedroom.js";
import { calculatePrimaryBedroom } from "./primary-bedroom.js";
import { calculateHomeOffice } from "./home-office.js";
import { calculateLaundryRoom } from "./laundry-room.js";
import { calculateMudroom } from "./mudroom.js";
import { calculateEntrywayFoyer } from "./entryway-foyer.js";
import { calculateHallway } from "./hallway.js";
import { calculateGarage } from "./garage.js";
import { calculateAttic } from "./attic.js";
import { calculateExterior } from "./exterior.js";
import { calculateWholeHome } from "./whole-home.js";
import type { ProjectCalculatorFn } from "./shared.js";

/**
 * Registry of project-type-specific calculators. A project type not
 * listed here has no wired-up pricing methodology yet - the engine falls
 * back to its honest zero-value placeholder result for it (see
 * engine.ts), the same way it does for a project type with an empty
 * pricing catalog. Adding a new project type's calculator here, plus its
 * pricing data (packages/pricing-data), is what "graduates" it from
 * placeholder to computed.
 */
const PROJECT_CALCULATORS: Partial<Record<ProjectType, ProjectCalculatorFn>> = {
  kitchen: calculateKitchen,
  bathroom: calculateBathroom,
  ensuite: calculateEnsuite,
  basement: calculateBasement,
  basement_suite: calculateBasementSuite,
  addition: calculateAddition,
  deck_patio: calculateDeckPatio,
  living_room: calculateLivingRoom,
  family_room: calculateFamilyRoom,
  dining_room: calculateDiningRoom,
  bedroom: calculateBedroom,
  primary_bedroom: calculatePrimaryBedroom,
  home_office: calculateHomeOffice,
  laundry_room: calculateLaundryRoom,
  mudroom: calculateMudroom,
  entryway_foyer: calculateEntrywayFoyer,
  hallway: calculateHallway,
  garage: calculateGarage,
  attic: calculateAttic,
  exterior: calculateExterior,
  whole_home_renovation: calculateWholeHome
};

export function getProjectCalculator(projectType: ProjectType): ProjectCalculatorFn | undefined {
  return PROJECT_CALCULATORS[projectType];
}

export type { ProjectCalculatorFn, ProjectCalculationOutput, AppliedLineItem } from "./shared.js";
